import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { FC } from 'react'
import Image from 'next/image'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { bestDisplayablePurchasePrices } from '@lifedot/utils'

const styles = {
  wrap: css({
    table: {
      margin: '20px 0'
    }
  })
}

interface CemeteryInfoProps {
  cemeteryId: number
}

export const CemeteryInfo: FC<CemeteryInfoProps> = ({ cemeteryId }) => {
  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])
  if (!cemetery) return null
  const {
    name,
    address,
    cemetery_types: cemeteryTypes,
    sects,
    main_image: mainImage
  } = cemetery
  const price = bestDisplayablePurchasePrices(cemetery.best_price_by_category)

  return (
    <div css={styles.wrap}>
      {mainImage?.path && (
        <Image
          src={mainImage.path}
          alt={mainImage.alt ?? name}
          width={860}
          height={484}
          objectFit="cover"
          priority
        />
      )}
      <table>
        <tbody>
          <tr css={typography.textS}>
            <th>所在地</th>
            <td>{address}</td>
          </tr>
          {price?.priceNumber && (
            <tr css={typography.textS}>
              <th>参考価格</th>
              <td>
                {price.priceNumber}
                {price.priceUnit}
                {price.priceSupplement}
              </td>
            </tr>
          )}
          <tr css={typography.textS}>
            <th>宗旨・宗派</th>
            <td>{sects.map(({ name }) => name).join('/')}</td>
          </tr>
          <tr css={typography.textS}>
            <th>霊園・種別</th>
            <td>
              {cemeteryTypes
                .filter(({ name }) => name !== '公営以外')
                .map(({ name }) => name)
                .join('/')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
